export default {
    ALL: 'all',
    CASH_BACK: 'cash-back',
    STORE_CREDIT: 'store-credit',
    TRAVEL: 'travel',
};
